import { render } from "./BaseSpinner.vue?vue&type=template&id=5147169a&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=5147169a&scoped=true&lang=css"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5147169a"]])

export default __exports__